import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete, TextField, Checkbox, FormControlLabel,
  Accordion, AccordionSummary, AccordionDetails,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Snackbar, Alert, Tooltip, IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LinkIcon from '@mui/icons-material/Link';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { createPortal } from 'react-dom';

import zapier     from '../../images/zapier.jpeg';
import make       from '../../images/make.jpg';
import integrately from '../../images/integrately.webp';

import { GetAll_stage_Data }        from '../../Redux/Actions/Stage_Action';
import { GetAllchannalData }         from '../../Redux/Actions/ChannalActions';
import { GetCommunicationwayData }   from '../../Redux/Actions/CommunicationWay_Action';
import { GetAllCampainData }         from '../../Redux/Actions/Campaign_Actions';
import { GetallProjectsdata }        from '../../Redux/Actions/Projects_Action';
import { Get_All_Sales_Action }      from '../../Redux/Actions/SalesAction';
import { Notify }                    from '../../Utility/Notify';
import { LeedintegrationKeys }       from './LeedintegrationKeys';
import { db_url }                    from '../../Api/BaseUrl';
import { useSidebarWidth }           from '../../Utility/useSidebarWidth';

/* ─── Integration platforms ─────────────────────────────────────────────── */
const allIntegration = [
  { id: 1, name: 'Zapier',      description: 'Connect with thousands of apps',  link: 'https://zapier.com',           img: zapier,      color: '#FF4F00' },
  { id: 2, name: 'Make',        description: 'Visual automation platform',       link: 'https://www.make.com/en',      img: make,        color: '#6E48AA' },
  { id: 3, name: 'Integrately', description: '1-click integrations',             link: 'https://app.integrately.com/', img: integrately, color: '#00A67E' },
];

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconPlus     = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconKey      = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>;
const IconClose    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconOpenLink = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>;
const IconCopy     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconCheck2   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;

/* ─── Keys Dialog (Portal) ───────────────────────────────────────────────── */
const KeysDialog = ({ isDark, onClose }) =>
  createPortal(
    <div onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} style={{
      position: 'fixed', inset: 0, zIndex: 999999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.65)', backdropFilter: 'blur(10px)',
      padding: '20px', animation: 'mi-fadein 0.2s ease both',
    }}>
      <style>{`@keyframes mi-fadein{from{opacity:0}to{opacity:1}} @keyframes mi-slidein{from{opacity:0;transform:translateY(20px) scale(0.97)}to{opacity:1;transform:translateY(0) scale(1)}}`}</style>
      <div style={{
        width: '100%', maxWidth: '780px', maxHeight: '85vh',
        background: isDark ? '#1e2132' : '#ffffff',
        borderRadius: '20px', overflow: 'hidden',
        border: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
        boxShadow: isDark ? '0 32px 80px rgba(0,0,0,0.55)' : '0 20px 60px rgba(0,0,0,0.15)',
        display: 'flex', flexDirection: 'column',
        animation: 'mi-slidein 0.26s cubic-bezier(0.34,1.15,0.64,1) both',
        fontFamily: "'DM Sans', sans-serif",
      }}>
        {/* header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '20px 28px',
          borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
          background: isDark ? '#161828' : '#f8fafc',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: '36px', height: '36px', borderRadius: '10px',
              background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
            }}><IconKey /></div>
            <div>
              <p style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0f172a' }}>Integration Keys</p>
              <p style={{ margin: 0, fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8' }}>Reference for API field names</p>
            </div>
          </div>
          <button onClick={onClose} style={{
            width: '34px', height: '34px', borderRadius: '10px',
            border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
            background: isDark ? '#252d45' : '#f8fafc',
            color: isDark ? '#9ca3af' : '#64748b',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer',
          }}><IconClose /></button>
        </div>
        {/* content */}
        <div style={{ overflowY: 'auto', padding: '24px 28px' }}>
          <LeedintegrationKeys />
        </div>
      </div>
    </div>,
    document.body
  );

/* ─── Question Accordion ─────────────────────────────────────────────────── */
const QuestionRow = ({ isDark, num, included, onToggle, text, onTextChange }) => (
  <Accordion sx={{
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    boxShadow: 'none', mb: 1,
    border: `1.5px solid ${included ? '#2563eb' : (isDark ? '#2d3248' : '#e2e8f0')}`,
    borderRadius: '10px !important',
    '&:before': { display: 'none' },
    transition: 'border-color 0.2s',
  }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: isDark ? '#6b7280' : '#94a3b8' }} />}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
        <FormControlLabel
          onClick={(e) => e.stopPropagation()}
          control={
            <Checkbox
              checked={included}
              onChange={(e) => { e.stopPropagation(); onToggle(e.target.checked); }}
              size="small"
              sx={{ color: '#2563eb', '&.Mui-checked': { color: '#2563eb' }, p: '4px' }}
            />
          }
          label={
            <span style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#374151', fontFamily: "'DM Sans', sans-serif" }}>
              Question {num}
            </span>
          }
        />
        {included && (
          <span style={{
            fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '20px',
            background: 'rgba(37,99,235,0.12)', color: '#2563eb', letterSpacing: '0.05em',
          }}>INCLUDED</span>
        )}
      </div>
    </AccordionSummary>
    <AccordionDetails sx={{ pt: 0, pb: 2 }}>
      <TextField
        fullWidth size="small"
        label={`Question ${num} Text`}
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        disabled={!included}
        placeholder="e.g., What is your budget?"
        required={included}
        error={included && !text}
        helperText={included && !text ? 'Question text is required' : 'ⓘ Answer will be provided by the customer in the form'}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            backgroundColor: isDark ? '#0f1117' : '#ffffff',
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            '& fieldset': { borderColor: isDark ? '#2d3248' : '#e2e8f0' },
            '&:hover fieldset': { borderColor: '#2563eb' },
            '&.Mui-focused fieldset': { borderColor: '#2563eb' },
          },
          '& .MuiInputLabel-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '13px' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#2563eb' },
          '& .MuiFormHelperText-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '11px' },
          '& .MuiInputBase-input': { color: isDark ? '#f1f5f9' : '#0f172a' },
          '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: isDark ? '#4b5563' : '#94a3b8' },
        }}
      />
    </AccordionDetails>
  </Accordion>
);

/* ─── Autocomplete shared sx ─────────────────────────────────────────────── */
const acSx = (isDark) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '14px',
    '& fieldset': { borderColor: isDark ? '#2d3248' : '#e2e8f0', borderWidth: '1.5px' },
    '&:hover fieldset': { borderColor: '#2563eb' },
    '&.Mui-focused fieldset': { borderColor: '#2563eb', boxShadow: '0 0 0 3px rgba(37,99,235,0.12)' },
  },
  '& .MuiInputLabel-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '13px' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#2563eb' },
  '& .MuiInputBase-input': { color: isDark ? '#f1f5f9' : '#0f172a' },
  '& .MuiSvgIcon-root': { color: isDark ? '#6b7280' : '#94a3b8' },
});

/* ─── Component ──────────────────────────────────────────────────────────── */
export const MoreIntegration = () => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const sidebarWidth = useSidebarWidth();

  const [userlogin, setUserlogin] = useState(null);
  const [keysOpen,  setKeysOpen]  = useState(false);
  const [copied,    setCopied]    = useState(false);
  const [copyOpen,  setCopyOpen]  = useState(false);
  const [urlcreated, setUrlcreated] = useState('');
  const [generated,  setGenerated]  = useState(false);

  /* fields */
  const [selectedProject,        setSelectedProject]        = useState(null);
  const [selectedSales,          setSelectedSales]          = useState(null);
  const [selectedStage,          setSelectedStage]          = useState(null);
  const [selectedChannal,        setSelectedChannal]        = useState(null);
  const [selectedCommunication,  setSelectedCommunication]  = useState(null);
  const [selectedCampaign,       setSelectedCampaign]       = useState(null);
  const [project,       setProject]       = useState('');
  const [salesdata,     setSalesdata]     = useState('');
  const [stage,         setStage]         = useState('');
  const [channal,       setChannal]       = useState('');
  const [commway,       setCommway]       = useState('');
  const [campaignid,    setCampaignid]    = useState('');
  const [redirectLink,  setRedirectLink]  = useState('');
  const [includeWhatsapp, setIncludeWhatsapp] = useState(false);
  const [includePhone2,   setIncludePhone2]   = useState(false);
  const [includeJobDesc,  setIncludeJobDesc]  = useState(false);

  /* questions */
  const [q, setQ] = useState([
    { included: false, text: '' },
    { included: false, text: '' },
    { included: false, text: '' },
    { included: false, text: '' },
    { included: false, text: '' },
  ]);
  const toggleQ   = (i, val) => setQ(prev => prev.map((x, idx) => idx === i ? { ...x, included: val } : x));
  const changeQTxt = (i, val) => setQ(prev => prev.map((x, idx) => idx === i ? { ...x, text: val } : x));

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  useEffect(() => {
    dispatch(GetAll_stage_Data());
    dispatch(GetAllchannalData());
    dispatch(GetCommunicationwayData());
    dispatch(GetAllCampainData());
    dispatch(GetallProjectsdata());
    dispatch(Get_All_Sales_Action());
  }, [dispatch]);

  const resStages   = useSelector((s) => s.Allstages.stage);
  const resChannal  = useSelector((s) => s.AllChannalRoot.channal);
  const resComm     = useSelector((s) => s.AllCommunicationway.communicationway);
  const resCampaign = useSelector((s) => s.AllCampaign.campaign);
  const resProjects = useSelector((s) => s.AllProjects.Projects);
  const resSales    = useSelector((s) => s.AllSales.sales);

  const stages    = Array.isArray(resStages?.data)   ? resStages.data   : [];
  const channels  = Array.isArray(resChannal?.data)  ? resChannal.data  : [];
  const commways  = Array.isArray(resComm?.data)     ? resComm.data     : [];
  const campaigns = Array.isArray(resCampaign?.data) ? resCampaign.data : [];
  const projects  = Array.isArray(resProjects?.data) ? resProjects.data : [];
  const salesData = (Array.isArray(resSales?.data) ? resSales.data : [])
    .filter(s => !['Default','Default M','Default T','Default S','Deveolper','Developer','Dev'].includes(s.name))
    .sort((a, b) => a.name === 'No Sales' ? -1 : b.name === 'No Sales' ? 1 : 0);

  let user = null;
  try { user = JSON.parse(localStorage.getItem('user')); } catch {}

  const dashboardRoute =
    userlogin?.data?.role === 'Admin'    ? '/dashboard'
  : userlogin?.data?.role === 'Marketer' ? '/dashboard'
  : '/';

  /* generate url */
  const generateUrl = () => {
    if (!project)     return Notify('error', 'Project is required', 'error');
    if (!salesdata)   return Notify('error', 'Sales is required', 'error');
    if (!channal)     return Notify('error', 'Channel is required', 'error');
    if (!commway)     return Notify('error', 'Communication way is required', 'error');
    if (!stage)       return Notify('error', 'Stage is required', 'error');
    if (!campaignid)  return Notify('error', 'Campaign is required', 'error');
    if (!user?.data?._id) return Notify('error', 'User is required', 'error');

    for (let i = 0; i < 5; i++) {
      if (q[i].included && !q[i].text)
        return Notify('error', `Question ${i + 1} text is required`, 'error');
    }

    const params = {
      addedby: user.data._id,
      stage, Channal: channal, project, salesdata,
      Communicationway: commway, campaignid,
      includePhone2: includePhone2 ? 'true' : 'false',
      includeWhatsapp: includeWhatsapp ? 'true' : 'false',
      includeJobDesc: includeJobDesc ? 'true' : 'false',
      ...q.reduce((acc, qi, i) => ({
        ...acc,
        [`includeQuestion${i+1}`]: qi.included ? 'true' : 'false',
        ...(qi.included && qi.text ? { [`question${i+1}_text`]: qi.text } : {}),
      }), {}),
      ...(redirectLink ? { campaignRedirectLink: redirectLink } : {}),
    };

    const queryParams = new URLSearchParams(params).toString();
    setUrlcreated(`${db_url}api/v1/users/create-with-params?${queryParams}`);
    setGenerated(true);
    setCopied(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(urlcreated);
    setCopied(true);
    setCopyOpen(true);
    setTimeout(() => setCopied(false), 2500);
  };

  /* section label style */
  const sectionLabel = (label, icon) => (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '8px',
      fontSize: '11px', fontWeight: 700, letterSpacing: '0.08em',
      textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8',
      margin: '4px 0 14px', padding: '0 0 10px',
      borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
    }}>
      {icon}<span>{label}</span>
    </div>
  );

  const checkboxStyle = { color: '#2563eb', '&.Mui-checked': { color: '#2563eb' }, p: '4px' };
  const checkLabel = (label) => (
    <span style={{ fontSize: '13px', color: isDark ? '#e2e8f0' : '#374151', fontFamily: "'DM Sans', sans-serif" }}>
      {label}
    </span>
  );

  return (
    <>
      <div style={{
        position: 'fixed',
        top: '50px', left: sidebarWidth, right: 0, bottom: 0,
        transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
        overflowY: 'auto', overflowX: 'hidden',
        background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
        fontFamily: "'DM Sans','Segoe UI',sans-serif",
        marginTop: '10px',
      }}>

        {/* ── Breadcrumb ── */}
        <div style={{
          padding: '14px 28px',
          backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
          display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', flexWrap: 'wrap',
        }}>
          <Link to={dashboardRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Dashboard</Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Integration</span>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>More Integration</span>
        </div>

        <div style={{ padding: '24px 28px 48px' }}>

          {/* ── Header ── */}
          <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <h1 style={{ fontSize: '22px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px', letterSpacing: '-0.4px' }}>
                Integration Hub
              </h1>
              <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
                Connect your leads with popular automation platforms
              </p>
            </div>
            {/* Keys button */}
            <button
              onClick={() => setKeysOpen(true)}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                padding: '10px 18px', borderRadius: '10px', border: 'none',
                background: isDark ? '#252d45' : '#f1f5f9',
                color: isDark ? '#93c5fd' : '#2563eb',
                fontSize: '13px', fontWeight: 700, cursor: 'pointer',
                border: `1.5px solid ${isDark ? '#2d3248' : '#dbeafe'}`,
                transition: 'all 0.2s', fontFamily: "'DM Sans', sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? '#1e3a8a22' : '#dbeafe'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = isDark ? '#252d45' : '#f1f5f9'; }}
            >
              <IconKey /> View Integration Keys
            </button>
          </div>

          {/* ── Integration Cards ── */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '16px', marginBottom: '28px' }}>
            {allIntegration.map((item) => (
              <a key={item.id} href={item.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <div style={{
                  borderRadius: '16px', overflow: 'hidden',
                  border: `1.5px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
                  background: isDark ? '#1e2132' : '#ffffff',
                  transition: 'all 0.2s', cursor: 'pointer',
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = `0 12px 32px ${item.color}30`;
                    e.currentTarget.style.borderColor = item.color;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'none';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.borderColor = isDark ? '#2a2f45' : '#e2e8f0';
                  }}
                >
                  <div style={{ position: 'relative', height: '120px', overflow: 'hidden' }}>
                    <img src={item.img} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    <div style={{ position: 'absolute', inset: 0, background: `linear-gradient(135deg,${item.color}50,transparent)` }} />
                  </div>
                  <div style={{ padding: '14px 16px', textAlign: 'center' }}>
                    <p style={{ margin: '0 0 4px', fontSize: '15px', fontWeight: 700, color: isDark ? '#f1f5f9' : item.color }}>{item.name}</p>
                    <p style={{ margin: '0 0 10px', fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8' }}>{item.description}</p>
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', gap: '4px',
                      padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 600,
                      background: item.color, color: '#fff',
                    }}>
                      Connect <IconOpenLink />
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* ── Configuration Card ── */}
          <div style={{
            backgroundColor: isDark ? '#1e2132' : '#ffffff',
            borderRadius: '20px', padding: '32px 36px',
            boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
            border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
          }}>

            {/* card title */}
            <div style={{ marginBottom: '24px' }}>
              <h2 style={{ fontSize: '18px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px' }}>
                Integration Configuration
              </h2>
              <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
                Fill in the required fields to generate your integration URL
              </p>
            </div>

            {/* Required */}
            {sectionLabel('Required Fields', <svg width="12" height="12" viewBox="0 0 24 24" fill="#ef4444"><circle cx="12" cy="12" r="10"/></svg>)}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'Project *',           options: projects,  getLabel: o => o.name,           val: selectedProject,       onChange: (_, v) => { setSelectedProject(v);       setProject(v?._id || ''); } },
                { label: 'Sales *',             options: salesData, getLabel: o => o.name,           val: selectedSales,         onChange: (_, v) => { setSelectedSales(v);         setSalesdata(v?._id || ''); } },
                { label: 'Stage *',             options: stages,    getLabel: o => o.name,           val: selectedStage,         onChange: (_, v) => { setSelectedStage(v);         setStage(v?._id || ''); } },
                { label: 'Channel *',           options: channels,  getLabel: o => o.name,           val: selectedChannal,       onChange: (_, v) => { setSelectedChannal(v);       setChannal(v?._id || ''); } },
                { label: 'Communication Way *', options: commways,  getLabel: o => o.name,           val: selectedCommunication, onChange: (_, v) => { setSelectedCommunication(v); setCommway(v?._id || ''); } },
                { label: 'Campaign *',          options: campaigns, getLabel: o => o.CampainName,    val: selectedCampaign,      onChange: (_, v) => { setSelectedCampaign(v);      setCampaignid(v?._id || ''); } },
              ].map((f) => (
                <Autocomplete
                  key={f.label}
                  options={f.options}
                  getOptionLabel={(o) => f.getLabel(o) || ''}
                  value={f.val}
                  onChange={f.onChange}
                  renderInput={(params) => (
                    <TextField {...params} label={f.label} size="small" sx={acSx(isDark)} />
                  )}
                />
              ))}
            </div>

            {/* Optional */}
            {sectionLabel('Basic Optional Fields', null)}
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
              {[
                { label: 'WhatsApp Number', val: includeWhatsapp, set: setIncludeWhatsapp },
                { label: 'Secondary Phone', val: includePhone2,   set: setIncludePhone2 },
                { label: 'Job Description', val: includeJobDesc,  set: setIncludeJobDesc },
              ].map((c) => (
                <div key={c.label} style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  padding: '8px 14px', borderRadius: '10px',
                  border: `1.5px solid ${c.val ? '#2563eb' : (isDark ? '#2d3248' : '#e2e8f0')}`,
                  background: c.val ? 'rgba(37,99,235,0.08)' : (isDark ? '#151827' : '#f8fafc'),
                  cursor: 'pointer', transition: 'all 0.18s',
                }} onClick={() => c.set(!c.val)}>
                  <div style={{
                    width: '16px', height: '16px', borderRadius: '4px',
                    border: `2px solid ${c.val ? '#2563eb' : (isDark ? '#4b5563' : '#cbd5e1')}`,
                    background: c.val ? '#2563eb' : 'transparent',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.18s', flexShrink: 0,
                  }}>
                    {c.val && <span style={{ color: '#fff', fontSize: '10px', fontWeight: 700 }}>✓</span>}
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: 500, color: c.val ? '#2563eb' : (isDark ? '#9ca3af' : '#64748b'), fontFamily: "'DM Sans', sans-serif" }}>
                    {c.label}
                  </span>
                </div>
              ))}
            </div>

            {/* Redirect link */}
            <div style={{ marginBottom: '24px' }}>
              <TextField
                fullWidth size="small"
                label="Campaign Redirect Link (Optional)"
                value={redirectLink}
                onChange={(e) => setRedirectLink(e.target.value)}
                placeholder="https://example.com/thank-you"
                helperText="URL to redirect after lead creation"
                InputProps={{ startAdornment: <LinkIcon sx={{ mr: 1, fontSize: 18, color: isDark ? '#6b7280' : '#94a3b8' }} /> }}
                sx={acSx(isDark)}
              />
            </div>

            {/* Questions */}
            {sectionLabel('Custom Questions', <HelpOutlineIcon sx={{ fontSize: 14 }} />)}
            <div style={{ marginBottom: '24px' }}>
              {q.map((qi, i) => (
                <QuestionRow
                  key={i} isDark={isDark} num={i + 1}
                  included={qi.included} onToggle={(v) => toggleQ(i, v)}
                  text={qi.text} onTextChange={(v) => changeQTxt(i, v)}
                />
              ))}
            </div>

            {/* divider */}
            <div style={{ height: '1px', background: isDark ? '#2a2f45' : '#e2e8f0', margin: '8px 0 24px' }} />

            {/* Generate button */}
            <button
              onClick={generateUrl}
              style={{
                width: '100%', padding: '15px', borderRadius: '12px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '14px', fontWeight: 700,
                letterSpacing: '0.06em', textTransform: 'uppercase',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans', sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}
            >
              <IconPlus /> Generate Integration URL
            </button>

            {/* Generated URL */}
            {generated && urlcreated && (
              <div style={{
                marginTop: '20px', padding: '16px 20px', borderRadius: '12px',
                background: isDark ? '#151827' : '#f0f7ff',
                border: `1.5px solid ${copied ? '#22c55e' : '#2563eb'}`,
                position: 'relative', transition: 'border-color 0.3s',
              }}>
                <p style={{ margin: '0 40px 0 0', fontSize: '12px', fontFamily: 'monospace', wordBreak: 'break-all', color: isDark ? '#93c5fd' : '#1d4ed8', lineHeight: 1.7 }}>
                  {urlcreated}
                </p>
                <button
                  onClick={handleCopy}
                  style={{
                    position: 'absolute', top: '12px', right: '12px',
                    width: '34px', height: '34px', borderRadius: '10px', border: 'none',
                    background: copied ? '#22c55e' : '#2563eb',
                    color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    cursor: 'pointer', transition: 'background 0.2s',
                  }}
                >
                  {copied ? <IconCheck2 /> : <IconCopy />}
                </button>
              </div>
            )}

          </div>
        </div>
      </div>

      {/* Keys Dialog */}
      {keysOpen && <KeysDialog isDark={isDark} onClose={() => setKeysOpen(false)} />}

      {/* Snackbar */}
      <Snackbar open={copyOpen} autoHideDuration={2000} onClose={() => setCopyOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity="success" sx={{ width: '100%' }}>URL copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};